import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/AgentWithdrawal`;


const AgentWithdrawal = {
  getAllUserWithdrawal: (params) => {
    console.log("params==========",params);
    const url = `${baseServiceUrl}/getAllAgentWithdrawal`;
    console.log("url==========",url);
    return ServiceApi.get(url,{params});
  },
  getUserWithdrawalById: (params) => {
    console.log("params==========",params);
    const url = `${baseServiceUrl}/getUserWithdrawalById`;
    console.log("url==========",url);
    return ServiceApi.get(url,{params});
  },
  getUserWithdrawalStatus: () => {
    // console.log("params==========",params);
    const url = `${baseServiceUrl}/getUserWithdrawalStatus`;
    console.log("url==========",url);
    return ServiceApi.get(url);
  },
  updateUserWithdrawal: (data) => {
    console.log(data);
    const url = `${baseServiceUrl}/updateUserWithdrawalStatus`;
    return ServiceApi.put(url, data);
  },
  createUserWithdrawal: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/createUserWithdrawal`;
    console.log("url==========", url);

    return ServiceApi.post(url, params);
},
removeAgentWithdrawal: (params) => {
  console.log("params==========",params);
  const url = `${baseServiceUrl}/removeAgentWithdrawal`;
  console.log("url==========",url);
  return ServiceApi.put(url,params);
}, 

};

export default AgentWithdrawal;


